import * as Redux from 'redux'

import {projectTab} from './ProjectPage.slices'

const projectPageReducer = Redux.combineReducers({
  tab: projectTab.reducer,
})
export default projectPageReducer
